import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import numeral from 'numeral'

import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0px ${theme.spacing(4)}px`,
  },
  title: {
    fontSize: 40,
    marginBottom: theme.spacing(2),
  },
  label: {
    marginTop: theme.spacing(1),
  },
})

const TitleWithLabel = ({
  classes, className, title, label
}) => (
  <div className={classNames(classes.root, className)}>
    <Typography className={classes.title} variant="h1">
      {title.length ? title : numeral(title).format('0,0')}
    </Typography>
    <Typography className={classes.label}>{label}</Typography>
  </div>
)

TitleWithLabel.defaultProps = {
  title: 0,
}

TitleWithLabel.propTypes = {
  label: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default withStyles(styles)(TitleWithLabel)



// WEBPACK FOOTER //
// ./src/components/atoms/TitleWithLabel.js